/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.14.1-13-ge76df34-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SetupState interface.
 */
export function instanceOfSetupState(value) {
    if (!('hasTargets' in value) || value['hasTargets'] === undefined)
        return false;
    if (!('hasUsers' in value) || value['hasUsers'] === undefined)
        return false;
    return true;
}
export function SetupStateFromJSON(json) {
    return SetupStateFromJSONTyped(json, false);
}
export function SetupStateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hasTargets': json['has_targets'],
        'hasUsers': json['has_users'],
    };
}
export function SetupStateToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'has_targets': value['hasTargets'],
        'has_users': value['hasUsers'],
    };
}
